// React import
import React, { Fragment, useEffect, useState, useCallback } from 'react';
//Material component import
import {Divider } from "@mui/material";
import { CircularProgress } from "@mui/material";
// custom component import
import dstyles from "./DailyProductionInsight.module.css";
import InsightTable from 'Samarth Module/components/table/insightTable';
import {ComposedChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, Label } from 'recharts';
import styles from "Samarth Module/components/barAndLineComboChart/barAndLineComboChart.module.css";


const AdoptionPlans = ({data, loader})=> {
    const [graphData, setGraphData] = useState([]);
    
    useEffect(() => {
        setGraphData(data);
    }, [data]);

    const CustomLegend = (props) => {
        const { payload } = props;
        return (
            <div style={{ display: 'flex', justifyContent: 'left', padding: '10px' }}>
                {payload.map((entry, index) => {
                    const { value, color } = entry;
                    return (
                        <span
                            key={`item-${index}`}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '4px',
                                padding: '0 10px',
                            }}
                        >
                            <span
                                style={{
                                    backgroundColor: color,
                                    width: '6px',
                                    height: '12px',
                                    display: 'inline-block',
                                    borderRadius: '2px',
                                }}
                            />
                            <span style={{ color: '#4D4D4F' }}>{value}</span>
                        </span>
                    );
                })}
            </div>
        );
    };

    const legendStyle = {
        fontSize: '10px',
        paddingTop: '15px',
        color: '#4D4D4F',
    };

    const CustomTooltip = ({ active, payload }) => {
        if (active && payload && payload.length) {
            return (
                <div className={styles.customTooltip}>
                    {payload.map((item, index) => (
                        <p key={index} className={styles.tooltipItem}>
                            <span style={{ fontWeight: 600 }}>{item.name}</span>&nbsp; : &nbsp;
                            {item.value}%
                        </p>
                    ))}
                </div>
            );
        }
        return null;
    };
	return(
		<Fragment>
            <div className={dstyles.adoptionDiv}>
                <div className={dstyles.planText}><span>Adoption % : System vs MM plan</span></div>
                <Divider className={dstyles.hr}/>
                {/* Line Graph */}
                {loader ? 
                    <div className={dstyles.loaderContainer}><CircularProgress /></div> :
                    
                    <ComposedChart data={graphData}
                        width={580}
                        height={382}
                        margin={{
                            top: 20,
                            right: 10,
                            bottom: 5,
                            left: 20,
                        }} 
                    >
                        <CartesianGrid strokeDasharray="3 3" vertical={false} horizontal={true} />
                        <XAxis dataKey="date" tickLine={false} axisLine={false} className={styles.BarLabel} padding={{ left: 0, right: 0 }} >
                            {/* <Label value="Past 4 Weeks" offset={10} position="bottom" style={{ fill: '#2B2B2B', fontSize: '10px', fontWeight: '500' }} /> */}
                        </XAxis>
                        <YAxis domain={[0, 'auto']}  axisLine={false} padding={{ left: 0, right: 0 }}
                            tick={{ 
                                fontSize: 10,           // <-- Decrease this number for smaller font
                                fill: '#2B2B2B', 
                                fontWeight: 400 
                            }}
                            label={{
                                value: 'Percentage (%)',
                                angle: -90,
                                position: 'left',
                                offset: 10,
                                style: {
                                    fill: '#2B2B2B',
                                    fontSize: '10px',
                                    fontWeight: '500',
                                    textAnchor: 'middle',
                                },
                            }}
                            // ticks={[0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]}
                            tickFormatter={(value) => `${value}%`}
                        />
                        <Tooltip
                            content={<CustomTooltip />}
                            wrapperStyle={{
                                fontSize: '12px',
                                padding: '6px',
                            }}
                        />
                        {/* <Legend verticalAlign="bottom" align="left" wrapperStyle={legendStyle} content={<CustomLegend />} /> */}

                        <Line type="monotone" dataKey="diffValue" name="System plan vs MM plan" stroke="#FFC000" fill="#FFC000" strokeWidth={1} />
                    </ComposedChart>
                }
            </div>
		</Fragment>
	);
}

export default AdoptionPlans;